import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { AI_USAGE_TABS } from '@/pages/settings/usage/ai-usage-tab';
import { UsageSettingsPage } from '@/pages/settings/usage/UsageSettingsPage';

const usageSearchSchema = z.object({
	tab: z.enum(AI_USAGE_TABS).optional(),
});

export const Route = createFileRoute('/_authenticated/_app/settings/usage')({
	component: UsageSettingsPage,
	validateSearch: usageSearchSchema,
});
